import { useFormikContext, Field } from "formik";

import React from "react";
import ErrorMessage from "../components/ErrorMessage"


function Age() {
    const { errors } = useFormikContext();
    
    const [showResults, setShowResults] = React.useState(false)
    const onClick = () => setShowResults(true)
    const hideResult = () => setShowResults(false)

  

  return (
    <div>
      <fieldset>
      <legend class="heading1">Age and family</legend>
     
        <ErrorMessage errors={errors}/>
            <div class="question-section">
                <h3 class="heading3">How old are you?</h3>
                <div class="form__control form__radio">
                    <Field data-agegroup="1" class="radio-button" type="radio" id="age_1825" name="age" value="18-25"/>
                    <label class="form__label" htmlFor="age_1825"><span>18-25</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field data-agegroup="1" class="radio-button" type="radio"  id="age_25pension" name="age" value="25-state"/>
                    <label class="form__label" htmlFor="age_25pension"><span>25- State Pension age</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field data-agegroup="1" class="radio-button" type="radio"  id="age_overpension" name="age" value="overstate"/>
                    <label class="form__label" htmlFor="age_overpension"><span>Over the State Pension age</span></label>
                </div>
            </div>
            <div class="question-section">
                <h3 class="heading3">Do you receive or have an entitlement to Carers Allowance?</h3>
                <div class="form__control form__radio">
                    <Field class="radio-button" type="radio" id="carer_yes" name="carer"value="1"/>
                    <label class="form__label" htmlFor="carer_yes"><span>Yes</span></label>
                </div>
                <div class="form__control form__radio">
                    <Field class="radio-button" type="radio"  id="carer_no" name="carer" value="0"/>
                    <label class="form__label" htmlFor="carer_no"><span>No</span></label>
                </div>
            </div>
            <div class="question-section">
                <h3 class="heading3">Are you a lone parent?</h3>
                <div class="form__control form__radio">
                    <Field data-agegroup="1" class="radio-button" type="radio" id="loneparent_yes" name="loneparent" value="loneparent" onClick={onClick}/>
                    <label class="form__label" htmlFor="loneparent_yes"><span>Yes</span></label>
                </div>

                

                {showResults &&
                
                    <div id="childreunder18" class="radio__reveal" >
                        <div class="form-group form__control">
                            <label htmlFor="childrenunder18" class="heading3">How many children under the age of 18 do you have living at this address?</label>
                            <Field class="input-width--100" type="text" inputmode="numeric" pattern="[0-9]*"  name="childrenunder18" />         
                        </div>                      
                    </div>
            
                 }
                
                
                <div class="form__control form__radio">
                    <Field class="radio-button" type="radio"  id="loneparent_no" name="loneparent" value="notloneparent" onClick={hideResult}/>
                    <label class="form__label" htmlFor="loneparent_no"><span>No</span></label>
                </div>
            </div>
      </fieldset>
    </div>
  );
}
export default Age;